module.exports = __webpack_public_path__ + "static/media/gameplay-01.8b5c2a64.gif";